// extracted by mini-css-extract-plugin
export default {"search":"newsbreak_search__USql1","fieldList":"newsbreak_fieldList__0uzQy","field":"newsbreak_field__MVniz","count":"newsbreak_count__uA8Wn","list":"newsbreak_list__qFZeP"};